<template>
  <div class="modal" :class="show? 'show': ''" :style="show? 'display:block;': ''" aria-hidden="true" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ 'Edit Task' }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form role="form" @submit.prevent="taskSubmit" class="col-md-12">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="todoList">Select todo list</label>
                <select id="todoList" v-model="todoId" class="form-control">
                  <option v-for="todo in todoList" :value="todo.id">{{ todo.displayName }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="taskTitle">Title</label>
                <input type="text" v-model="task.title" class="form-control" id="taskTitle" name="taskTitle" placeholder="Add a title">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="taskDueDate">Task due date</label>
                <datepicker id="taskDueDate" :value="new Date()" name="taskDueDate" :input-class="['form-control']" :format="dateFormat" @input="selectDueDate" :use-utc="true"></datepicker>
              </div>
              <div class="form-group col-md-6">
                <label for="taskDueTime">Task due time</label>
                <vue-timepicker id="taskDueTime" close-on-complete v-model="taskDueTime" hide-clear-button/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="taskImportance">Importance</label>
                <select id="taskImportance" v-model="task.importance" class="form-control">
                  <option value="low">Low</option>
                  <option value="normal">Normal</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label for="taskReminder">Reminder</label>
                <bootstrap-toggle v-model="task.isReminderOn" id="taskReminder" name="taskImportance" :options="{ on:'Yes', off: 'No' }"/>
              </div>
              <div class="form-group col-md-3" :style="task.isReminderOn? 'display:block;' : 'display:none;'">
                <label for="taskReminderDate">Reminder date</label>
                <datepicker id="taskReminderDate" :value="new Date()" name="taskReminderDate" :input-class="['form-control']" :format="dateFormat"
                            @input="selectReminderDate" :use-utc="true"></datepicker>
              </div>
              <div class="form-group col-md-3" :style="task.isReminderOn? 'display:block;' : 'display:none;'">
                <label for="taskReminderTime">Reminder time</label>
                <vue-timepicker id="taskReminderTime" close-on-complete v-model="reminderTime" hide-clear-button/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="taskStatus">Status</label>
                <select id="taskStatus" v-model="task.status" class="form-control">
                  <option value="notStarted">Not Started</option>
                  <option value="inProgress">In Progress</option>
                  <option value="waitingOnOthers">Waiting On Others</option>
                  <option value="completed">Completed</option>
                  <option value="deferred">Deferred</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="taskDescription">Task description</label>
                <textarea class="form-control" id="taskDescription" rows="5" name="taskDescription" placeholder="Add a description" v-model="task.body.content"/>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveTask()">Save</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "vue-select/src/scss/vue-select.scss";
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: 'TaskModal',
  components: {
    vSelect,
    Datepicker,
    VueTimepicker,
    BootstrapToggle
  },
  props: {
    show: Boolean,
    info: Object
  },
  data() {
    return {
      task: {
        title: "",
        importance: "low",
        isReminderOn: false,
        status: "notStarted",
        body: {
          content: "",
          contentType: "text"
        },
        dueDateTime: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        // recurrence: {
        //
        // },
        reminderDateTime: {
          dateTime: "",
          timeZone: "Europe/London"
        }
      },
      dueDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
      taskDueTime: "00:00",
      reminderDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
      reminderTime: "00:00",
      todoId: "",
      todoList: [],
      repeat: "never",
      taskId: "",
    }
  },
  mounted() {
    this.todoList = this.info.todoList;
    this.todoId = this.info.todoId;
    this.taskId = this.info.taskId;
    this.setTask();
  },
  methods: {
    taskSubmit() {

    },
    setTask() {
      this.task.title = this.info.task.title;
      this.dueDate = this.$moment.utc(new Date(this.info.task.dueDateTime.dateTime)).format("YYYY-MM-DD");
      this.taskDueTime = this.$moment.utc(new Date(this.info.task.dueDateTime.dateTime)).format("HH:mm");
      this.task.importance = this.info.task.importance;
      this.task.isReminderOn = this.info.task.isReminderOn;
      if (this.task.isReminderOn) {
        this.reminderDate = this.$moment.utc(new Date(this.info.task.reminderDateTime.dateTime)).format("YYYY-MM-DD");
        this.reminderTime = this.$moment.utc(new Date(this.info.task.reminderDateTime.dateTime)).format("HH:mm");
      }
      else {
        this.reminderDate = this.$moment.utc(new Date()).format("YYYY-MM-DD");
        this.reminderTime = "00:00";
      }
      this.task.status = this.info.task.status;
      if (this.info.task.recurrence) {
        this.repeat = this.info.task.recurrence.pattern.type;
      }
      else {
        this.repeat = "never";
      }
      this.task.body.content = this.info.task.body.content;
    },
    isEmpty(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    selectDueDate(date) {
      if (date != null) {
        this.dueDate = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    saveTask() {
      this.task.dueDateTime.dateTime = this.dueDate + this.getTimeFormat(this.taskDueTime);
      // this.task.recurrence = this.getRecurrenceObject(this.repeat);
      if (this.task.isReminderOn) {
        this.task.reminderDateTime.dateTime = this.reminderDate + this.getTimeFormat(this.reminderTime);
      }
      else {
        this.task.reminderDateTime = undefined;
      }
      // console.log(this.task);
      axios.patch(this.crmApiPath + 'msgraph/todo/lists/' + this.todoId + '/tasks/' + this.taskId, this.task).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.$emit('close');
        }
      }).catch(error => console.log(error));
    },
    selectReminderDate(date) {
      if (date != null) {
        this.reminderDate = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    getTodoList() {
      axios.get(this.crmApiPath + 'msgraph/todo/lists').then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.todoList = response.data.lists.data.value.filter(function (elem) {
            return elem.isOwner;
          });
          this.todoId = this.todoList[0].id;
        }
      }).catch(error => console.log(error));
    },
    getRecurrenceObject(str) {
      if (str === "never") {
        return null;
      }
      else if (str === "daily") {
        return {
          pattern: {
            type: "daily",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "weekly") {
        return {
          pattern: {
            type: "weekly",
            interval: 1,
            daysOfWeek: [this.getWeekString(this.dueDate)]
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "monthly") {
        return {
          pattern: {
            type: "absoluteMonthly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "yearly") {
        return {
          pattern: {
            type: "absoluteYearly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else {
        return null;
      }
    },
    getGeneralRange() {
      return {
        type: "noEnd",
        startDate: this.dueDate
      };
    },
    getWeekString(date) {
      const dayOfWeek = new Date(date).getDay();
      return isNaN(dayOfWeek) ? null : ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayOfWeek];
    },
    getTimeFormat(str) {
      return "T" + str + ":00.0000000";
    },
  },
}
</script>
<style scoped lang="scss">
.modal-dialog {
  min-height:      calc(100vh - 60px);
  display:         flex;
  flex-direction:  column;
  justify-content: center;
  overflow:        auto;
}

@media(max-width: 768px) {
  .modal-dialog {
    min-height: calc(100vh - 20px);
  }
}
</style>
